<template>
  <div class="overflow-x justify-content-center mt-5">
      <div class=" p-list-representation-table-main">
        <table class="table table-bordered p-table">
            <thead>
              <tr>
                <th >نام و نام خانوادگی</th>
                <th>تاریخ تولد</th>
                <th >جنسیت</th>
                <th >موبایل</th>
                <th ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in tableData" :key="data.id">
                <th scope="row">{{data.name }} {{data.family }}</th>
                <th scope="row">{{data.dateConvertedJali}}</th>
                <th scope="row">{{allEnums.gender[data.gender]}}</th>
                <th scope="row">{{data.mobile}}</th>
                <td>
                    <div class="d-flex justify-content-end flex-column">
                            <div class="row w-100 mb-2 justify-content-center">
                                <button @click="transactionWallet(data)" type="button" class="btn btn-primary btn-blue btn-sm ml-2 btn-table ">
                                  گردش کیف پول
                                </button>
                            </div>
                    </div>
                </td>

              </tr>

            </tbody>
          </table>
          <div class="d-flex justify-content-center p-table">
            <pagination v-model="valuePage" :per-page="20" :records="500" @paginate="changePage"/>
          </div>
      </div>

  </div>
</template>

<script>
import addCama from '../../modules/addCama.js'


export default {
    name: 'tableContent',
    props: {
      page      : { type: Number, default: 0 },
      tableData : { type: [Object, Array], default: [] },
      allEnums  : { type: [Object, Array], default: {} },

    },

    data() {
      return {
        valuePage : 1,
      }
    },

    computed: {

    },

    mounted () {
      this.valuePage = this.page;
    },

    watch: {
      page(data){
        this.valuePage = this.page;
      },
    },

    methods: {
      changePage(data){
        this.$emit("paganationChangePage",data);
      },

      transactionWallet(data){
        this.$router.push({name:'walletPlayer' , params:{id:data.id} , query:data })
      },


    },

}
</script>
